/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EscrowCompletedEvent = {
  escrowId: bigint;
  agent: Address;
  amount: bigint;
};

export type EscrowCompletedEventArgs = {
  escrowId: number | bigint;
  agent: Address;
  amount: number | bigint;
};

export function getEscrowCompletedEventEncoder(): FixedSizeEncoder<EscrowCompletedEventArgs> {
  return getStructEncoder([
    ["escrowId", getU64Encoder()],
    ["agent", getAddressEncoder()],
    ["amount", getU64Encoder()],
  ]);
}

export function getEscrowCompletedEventDecoder(): FixedSizeDecoder<EscrowCompletedEvent> {
  return getStructDecoder([
    ["escrowId", getU64Decoder()],
    ["agent", getAddressDecoder()],
    ["amount", getU64Decoder()],
  ]);
}

export function getEscrowCompletedEventCodec(): FixedSizeCodec<
  EscrowCompletedEventArgs,
  EscrowCompletedEvent
> {
  return combineCodec(
    getEscrowCompletedEventEncoder(),
    getEscrowCompletedEventDecoder(),
  );
}
